import {Repository, createRepository} from '@/repositories/Base/Repository'

class ImportLangRepository extends Repository {
    endpoint = 'loinc/exams_langs/to'

    cleanAll(params) {
        return this.$axios.delete(`${this.endpoint}/import/do/clean`, params)
    }

    import(params) {
        return this.$axios.post(`${this.endpoint}/import`, params)
    }

    fetchAllCreated(params) {
        return this.$axios.get(`${this.endpoint}/create`, {params})
    }

    postCreated(params) {
        return this.$axios.post(`${this.endpoint}/create`, params)
    }

    fetchAllUpdated(params) {
        return this.$axios.get(`${this.endpoint}/update`, {params})
    }

    postUpdated(params) {
        return this.$axios.post(`${this.endpoint}/update`, params)
    }
}

export default new ImportLangRepository()

export const create = createRepository(ImportLangRepository)
